module.exports = __webpack_public_path__ + "img/activity.14ee5d8c.svg";